import React from 'react'

//Final Form
import { Form } from 'react-final-form'
import arrayMutators from 'final-form-arrays'

//Material-UI
import Grid from '@material-ui/core/Grid'
import makeStyles from '@material-ui/core/styles/makeStyles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import useTheme from '@material-ui/core/styles/useTheme'

import Button from '../../../../../control/button/button'
import Dialog from '../../../../../control/dialog/dialog'
import TextField from '../../../../../control/textfield/textfield'
import UploadDoc from '../../../shareUI/uploadDoc/uploadDoc'
import MyAccordion from '../../../../../control/accordion/accordion'

import useTranslate from '../../../../../i18n/useTranslate'
import ButtonSubmittedWithdraw from '../_sharedPageComponent/buttonSubmittedWithdraw/buttonSubmittedWithdraw'
import useConfirmSubmittedWithdraw from './useConfirmSubmittedWithdraw'
import useAppFolderAndTabStore from '../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import submittedType from '../../../../../constants/submittedType'
import UploadAdditionalDoc from '../../../shareUI/uploadAdditionalDoc/UploadAdditionalDoc'
import useCheckPermission from '../../../../../utilities/checkPermission'

type ConfirmProjectWithDrawViewProps = ReturnType<typeof useConfirmSubmittedWithdraw> & ConfirmSubmittedWithdrawProps
const ConfirmSubmittedWithdrawView: React.FC<ConfirmProjectWithDrawViewProps> = (props) => {
    const {
        initialVal,
        initialUploadFile,
        uploadDocumentTopic,
        isViewMode,
        configDialog,
        onRefDialog,
        onConfirmWithdraw,
    } = props
    const classes = useStyles()
    const translate = useTranslate()
    const theme = useTheme()
    const checkPermission = useCheckPermission()
    const isMobileView = useMediaQuery(theme.breakpoints.down('xs'))
    const { folderSelected } = useAppFolderAndTabStore()
    return (
        <Form
            onSubmit={() => {}}
            mutators={{
                ...arrayMutators,
            }}
            initialValues={initialVal}
            keepDirtyOnReinitialize={true}
        >
            {() => {
                return (
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <MyAccordion title={translate.get('LABEL.WITHDRAW_REASON')}>
                                <TextField
                                    name="withdrawCause"
                                    materialInputProps={{
                                        label: translate.get('LABEL.REASON'),
                                        disabled: true,
                                        multiline: true,
                                        rows: 5,
                                    }}
                                    maxLength={1000}
                                    resetButtom
                                />
                            </MyAccordion>
                        </Grid>
                        <Grid item xs={12}>
                            <UploadDoc
                                initialData={initialUploadFile}
                                documentTitleList={uploadDocumentTopic}
                                isViewMode={true}
                                latestDocument={undefined}
                                isUseUploadfileEdit={false}
                                isRequire={false}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <UploadAdditionalDoc isViewMode={true} isEditable={checkPermission.isUserAdmin()} />
                        </Grid>

                        {!isViewMode && (
                            <Grid item xs={12}>
                                <Grid container item justify="space-between" spacing={2}>
                                    <Grid item xs={12} sm={'auto'}>
                                        <ButtonSubmittedWithdraw
                                            gridProps={{ xs: false }}
                                            fullWidth={isMobileView ? true : false}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={'auto'}>
                                        <Button
                                            size={'medium'}
                                            variant="contained"
                                            color="primary"
                                            onClick={onConfirmWithdraw}
                                            className={classes.saveButton}
                                            fullWidth={isMobileView ? true : false}
                                        >
                                            {folderSelected?.folderName_th?.includes('แก้ไขหลังพิจารณา')
                                                ? translate.get('BUTTON.SAVE_CANCEL_SUBMITTED_WITHDRAW')
                                                : translate.get('BUTTON.SAVE_WITHDRAW')}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}

                        <Dialog onRef={onRefDialog} {...configDialog} />
                    </Grid>
                )
            }}
        </Form>
    )
}

export type ConfirmSubmittedWithdrawProps = {
    onSaveComplete?: (status: number, isDraft: boolean) => void
}
const ConfirmProjectWithdraw: React.FC<ConfirmSubmittedWithdrawProps> = (props) => {
    const model = useConfirmSubmittedWithdraw(props)
    return <ConfirmSubmittedWithdrawView {...model} {...props} />
}

const useStyles = makeStyles((theme) => ({
    saveButton: {
        border: 'solid 1px #db5f8e',
    },
    cancelButton: {
        backgroundColor: '#FFFFFF',
        border: 'solid 1px #db5f8e',
        [theme.breakpoints.down('xs')]: {
            marginTop: '16px',
        },
    },
    container: {
        padding: '8px 0px',
    },
}))
export default ConfirmProjectWithdraw
